import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📦 Components`}</h2>
    <ul>
      <li parentName="ul">{`Zhaotong P. will be leading Thumbprint Web efforts going forward. Zhaotong joins the Thumbprint extended family with Mallika P. on Android and Kevin B. on iOS.`}</li>
      <li parentName="ul">{`The FAB components for iOS and Android have shipped! It is in progress for web. (Eric S., Patrick A.)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Modal`}</inlineCode>{` and `}<inlineCode parentName="li">{`ModalCurtain`}</inlineCode>{` for web are being converted to TypeScript. (Giles L.)`}</li>
      <li parentName="ul">{`We’ve gathered and are analyzing results for the Android design systems survey. Thanks to those that filled it out! (Mallika P.)`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`Email reviews are continuing with final component spec delivery starting this week. (Jon K.)`}</li>
      <li parentName="ul">{`We’re wrapping up design work on improvements to the `}<inlineCode parentName="li">{`Modal`}</inlineCode>{` components. (Lucas S.)`}</li>
    </ul>
    <h2>{`📖 Documentation`}</h2>
    <ul>
      <li parentName="ul">{`Email documentation is ready and will be integrated once components are finalized. (Daniel O., Tom G.)`}</li>
      <li parentName="ul">{`We’re changing the layout of the thumbprint.design `}<a parentName="li" {...{
          "href": "https://thumbprint.design/components/overview/"
        }}>{`component overview page`}</a>{` to make easier to search and filter components by platform. (Daniel O., Tom G.)`}</li>
      <li parentName="ul">{`We’ve created a component adoption tracker in Coda. (Daniel O.)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      